if (window.self !== window.top) {
   document.body.innerHTML = '<h1>Acceso no permitido</h1>';
   throw new Error('Bloqueo por clickjacking');
}

import { createApp } from 'vue';
import '@/assets/css/styles.css';
import App from './App.vue';
import router from './router';
import store from './store';
import PrimeVueConfig from '@/helpers/primevue';

const app = createApp(App);

app.use(router);
app.use(store);
app.use(PrimeVueConfig);

app.mount('#app');
